import React, { useState } from "react";
import parse from "html-react-parser";
import config from "config";
import { formFeaturesList } from "../Helpers.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import Button from "components/Elements/Button/Button.js";

const FormFeaturesSection = () => {
  const { getTextByKey, getHtmlByKey, getPath } = useContent();
  const [activeFeature, setActiveFeature] = useState(null);
  const { newMobileCondition } = useMediaQueries();

  const covertSeePremiumText = (text) => {
    let newText = text;
    let newUrl = config.baseurl + getPath() + "plans";
    if (text.includes("#premium-plans-url#")) {
      newText = newText.replace("#premium-plans-url#", newUrl);
    }
    return newText;
  };
  return (
    <div className="form-features-section">
      <div className="content-container">
        <div className="div-title-2">
          <div className="features-2-content">
            <h2>{getTextByKey("form-features-title2")}</h2>
            {newMobileCondition ? (
              <div className="form-features-mobile">
                {formFeaturesList.map((feature, index) => (
                  <div
                    className={`form-feature ${
                      activeFeature === index ? "active" : ""
                    }`}
                    key={index}
                    onClick={() =>
                      setActiveFeature(activeFeature === index ? null : index)
                    }
                  >
                    <div className="accordion-title-div">
                      <div className="title-and-image">
                        <div className="image">
                          <Image
                            name={`embed-forms/${feature.image}`}
                            ext="svg"
                            alt=""
                            title=""
                          />
                        </div>
                        <div className="title-feature">
                          <h3>{getTextByKey(feature.title)}</h3>
                        </div>
                      </div>
                      <div
                        className={`arrow-down-container ${
                          activeFeature === index
                            ? "active-arrow"
                            : "unactive-arrow"
                        }`}
                      >
                        <Icon name="arrow-down" />
                      </div>
                    </div>
                    <p
                      className={`${
                        activeFeature === index ? "active" : "unactive"
                      }`}
                    >
                      {getTextByKey(feature.text)}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <div className="form-features">
                {formFeaturesList.map((item, index) => {
                  return (
                    <div className={`form-feature`} key={index}>
                      <div className="form-feature-card">
                        <div className="title-card-div">
                          {item.image && (
                            <Image
                              name={`embed-forms/${item.image}`}
                              ext="svg"
                              alt=""
                              title=""
                            />
                          )}
                          <p className="title-card">
                            {getTextByKey(item.title)}
                          </p>
                        </div>
                        <div className="text-card-div">
                          <p className="text-card">{getTextByKey(item.text)}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            <p className="footer-section">
              {getHtmlByKey("compare-premium-plans")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormFeaturesSection;
